module.exports = __webpack_public_path__ + "img/default_league.604c78c6.png";